import React from "react";
import { Link } from "react-router-dom";
import SchoolHero from "../components/SchoolLevels/SchoolHero";
import "../css/Curriculum.css";

const classroomImg = "./images/m.jpeg";
const studentsImg = "./images/pre.jpg";

const Curriculum = () => {
  return (
    <>
      <div className="curriculum-page">
        <SchoolHero
        title="CURRICULUM"
        subtitle="World-Class Infrastructure"
         image="./images/high.jpg"
      />
        <section className="gmp-section">
          <div className="gmp-main-card">
            <div className="gmp-content-wrapper">
              {}
              <div className="gmp-info-side">
                <div className="gmp-header">
                  <h2>SAHARA PUBLIC SECONDARY SCHOOL (SAHARA)</h2>
                </div>

                <div className="gmp-body">
                  <div className="gmp-meta">
                    <span className="grade-info">
                      <strong>Grade:</strong> Pre KG-K2
                    </span>
                    <span className="enroll-status">
                      {" "}
                      <i className="check-icon">✔</i> Enrolling Now
                    </span>
                  </div>

                  <p className="gmp-description">
                    At Sahara, we recognise the importance of learning and
                    holistic development during a child's formative years. Our{" "}
                    <span className="blue-text">pre-primary programme</span>{" "}
                    provides a safe, nurturing environment where children can
                    begin building their skills and exploring their talents
                    through age-appropriate activities. By encouraging young
                    children's natural curiosity, we begin to set the stage for
                    lifelong learning. By meeting our children where they are,
                    we recognise that each child is a unique, highly valued
                    member of our school community.
                  </p>

                  <Link to="/primarycurricula" className="btn btn-primary">
                    READ MORE <i>›</i>
                  </Link>
                </div>

                {}
                <div className="gmp-footer-bar">
                  <div className="footer-item">
                    <Link to="/book-meeting">
                      {" "}
                      <span className="icon">🤝</span>
                      <span>Book A Meeting</span>
                    </Link>
                  </div>
                  <div className="footer-item">
                    <Link to="/admissionenquiryform">
                      <span className="icon">📄</span>
                      <span>Admission Form</span>
                    </Link>
                  </div>
                  <div className="footer-item">
                    <Link to="/feestructure">
                      <span className="icon">💵</span>
                      <span>Fee</span>
                    </Link>
                  </div>
                </div>
              </div>

              {}
              <div className="gmp-image-side">
                <img
                  src={classroomImg}
                  alt="Classroom"
                  className="classroom-img"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="cbse-section">
          <div className="cbse-main-card">
            <div className="cbse-content-wrapper">
              {}
              <div className="cbse-image-side">
                <img
                  src={studentsImg}
                  alt="CBSE Students"
                  className="cbse-img"
                />
              </div>

              {}
              <div className="cbse-info-side">
                <div className="cbse-header">
                  <h2>Secondary Education Examination Board (SEEB)</h2>
                </div>

                <div className="cbse-body">
                  <div className="cbse-meta">
                    <span className="grade-info">
                      <strong>Grade:</strong> 1 - 9
                    </span>
                    <span className="enroll-status">
                      {" "}
                      <i className="check-icon">✔</i> Enrolling Now
                    </span>
                  </div>

                  <p className="cbse-description">
                    Our SEEB programme is available for children from Grade 1
                    onwards. With a strong emphasis on academics, the SEEB
                    programme also encourages children to cultivate their skills
                    and talents through extracurricular activities, such as
                    sports and the arts. Our comprehensive evaluation system
                    recognises children's individual accomplishments and
                    empowers them to reach their highest potential.
                  </p>

                  <Link  to="/seeb"  className="btn btn-primary">
                    READ MORE <i>›</i>
                  </Link>
                </div>

                {}
                <div className="cbse-footer-bar">
                  <div className="footer-item">
                    <Link to="/book-meeting">
                      <span className="icon">🤝</span>
                      <span>Book A Meeting</span>
                    </Link>
                  </div>
                  <div className="footer-item">
                    <Link to="/admissionenquiryform">
                      <span className="icon">📄</span>
                      <span>Admission Form</span>
                    </Link>
                  </div>
                  <div className="footer-item">
                    <Link to="/feestructure">
                      <span className="icon">💵</span>
                      <span>Fee</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Curriculum;
